import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getProfile = () => {
    return api.get(ENDPOINTS.PROFILE.GET);
};

export const updateProfile = (data) => {
    return api.put(ENDPOINTS.PROFILE.UPDATE, data);
};

export const changePassword = (data) => {
    return api.put(ENDPOINTS.PROFILE.CHANGE_PASSWORD, data);
};
